import React from 'react';
import PropTypes from 'prop-types';

import { LOCATION_LIST_PROPTYPES } from 'bento-ordering/base/constants/propTypes';

import LocationsList from 'components/Location/LocationsList';
import LocationListSection from 'bento-ordering/locations/components/LocationListSection';

function SortedLocations({
  beginOrder,
  closedLocations,
  locationsThatDeliverToAddress,
  locationsForPickup,
  LocationsListItemComponent,
  selectedMapLocation
}) {
  return (
    <>
      {!!locationsThatDeliverToAddress.length && (
        <LocationListSection
          title="Delivers to your address"
          dataTestId="delivery-locations"
        >
          <LocationsList
            beginOrder={beginOrder}
            locations={locationsThatDeliverToAddress}
            LocationsListItemComponent={LocationsListItemComponent}
            selectedMapLocation={selectedMapLocation}
          />
        </LocationListSection>
      )}

      {!!locationsForPickup.length && (
        <LocationListSection
          title="Pickup locations"
          dataTestId="pickup-locations"
        >
          <LocationsList
            beginOrder={beginOrder}
            locations={locationsForPickup}
            LocationsListItemComponent={LocationsListItemComponent}
            selectedMapLocation={selectedMapLocation}
          />
        </LocationListSection>
      )}
      {!!closedLocations.length && (
        <LocationListSection
          title="Other locations"
          dataTestId="closed-locations"
        >
          <LocationsList
            beginOrder={beginOrder}
            locations={closedLocations}
            LocationsListItemComponent={LocationsListItemComponent}
            selectedMapLocation={selectedMapLocation}
          />
        </LocationListSection>
      )}
    </>
  );
}

SortedLocations.propTypes = {
  beginOrder: PropTypes.func.isRequired,
  closedLocations: LOCATION_LIST_PROPTYPES,
  LocationsListItemComponent: PropTypes.elementType.isRequired,
  locationsForPickup: LOCATION_LIST_PROPTYPES,
  locationsThatDeliverToAddress: LOCATION_LIST_PROPTYPES,
  selectedMapLocation: PropTypes.number
};

export default SortedLocations;
